import React from 'react'
import PropTypes from 'prop-types'

import LocationListItem from 'containers/LocationListItem'

import './index.scss'

class LocationList extends React.Component {
  renderItems () {
    return this.props.locations.map(location => {
      return (
        <LocationListItem
          key={`location${location.id}`}
          location={location} />
      )
    })
  }

  render () {
    return (
      <div>
        <ul className='location-list'>{ this.renderItems() }</ul>
      </div>
    )
  }
}

LocationList.propTypes = {
  locations: PropTypes.array
}

export default LocationList



// WEBPACK FOOTER //
// ./src/components/LocationList/index.js